// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"88":"5efb69d8","142":"7708d09f","272":"a4ef8075","330":"a432169a","401":"441dc1ab","488":"6414fce0"}[chunkId] + ".chunk.js";
};